import Animation from 'component/Animation'
import animationData from './loadingBar7.json'

export default function LoadingEffect(props: Record<string, any>) {
  return <Animation {...props} animationData={animationData} />
}
